import AccountService from '../services/integrations/AccountService';
import { getUserProfile } from '../services/integrations/CustomAccountService';
import { Auth } from 'aws-amplify';
import { setLocalStorage } from '../utils/localstorage';
import type { CognitoSession } from '../../types/account';
import { useAccountStore } from '../stores/AccountStore';

export class AuthPresenter {
  private readonly accountService: AccountService;

  constructor(accountServices: AccountService) {
    this.accountService = accountServices;
  }

  refreshToken = async (user: any) => {
    try {
      const inplayerToken = JSON.parse(localStorage.getItem('inplayer_token') || '{}');
      const expTime = inplayerToken.exp;

      const currentTime = Math.floor(Date.now() / 1000);

      if (expTime < currentTime) {
        const currentSession: any = await Auth.currentSession();

        user.refreshSession(currentSession.refreshToken, (err: object, session: CognitoSession) => {
          const token = {
            token: 'session.idToken.jwtToken',
            refreshToken: session.refreshToken.token,
            expires: session.idToken.payload.exp,
          };
          localStorage.setItem('inplayer_token', JSON.stringify(token));
        });
      }
    } catch (e) {
      console.log('Unable to refresh Token', e);
    }
  };

  loadUserData = async () => {
    const user = await Auth.currentAuthenticatedUser();
    useAccountStore.setState((s) => ({
      ...s,
      cognitoUser: user
    }));
    const token = {
      token: user.signInUserSession.idToken.jwtToken,
      refreshToken: user.signInUserSession.refreshToken.token,
      expires: user.signInUserSession.idToken.payload.exp,
    };
    await setLocalStorage('userEmail', user.signInUserSession.idToken.payload.email);
    await setLocalStorage('inplayer_token', token);
    await setLocalStorage('access_token', user.signInUserSession.accessToken.jwtToken);
    if (user.storage && user.storage['jwapp.language']) {
      setLocalStorage('jwapp.language', user.storage['jwapp.language']);
    }
    const userData: any = await getUserProfile();
    return { userData, user };
  };

  useRefreshToken = async () => {
    const user = await Auth.currentAuthenticatedUser();
    this.refreshToken(user);
  };

  getAccountDetails = async () => {
    return this.loadUserData();
  };
}
